import React from 'react'

const Page404: React.FC = () => {
  return <>404</>
}

export default Page404
